import { 
  ALL_GRAMMAR_TOPICS, 
  GRAMMAR_CATEGORIES as CATS, 
  CEFR_LEVELS as LEVELS 
} from './grammar/index';

/**
 * grammarData.js
 * 
 * This file is now a wrapper around the modular files in /data/grammar/
 * to maintain compatibility with existing imports.
 */

export const GRAMMAR_CATEGORIES = CATS;
export const CEFR_LEVELS = LEVELS;
export const GRAMMAR_TOPICS = ALL_GRAMMAR_TOPICS;
